'use client';

var display = {
    extraLarge: {},
    large: {
        'font-size': '57px',
        'font-weight': '400',
        'line-height': '64px'
    },
    medium: {
        'font-size': '45px',
        'font-weight': '400',
        'line-height': '52px'
    },
    small: {
        'font-size': '36px',
        'font-weight': '400',
        'line-height': '44px'
    }
};
var headline = {
    extraLarge: {},
    large: {
        'font-size': '32px',
        'font-weight': '600',
        'line-height': '40px'
    },
    medium: {
        'font-size': '28px',
        'font-weight': '600',
        'line-height': '36px'
    },
    small: { 'font-size': '24px', 'font-weight': '600', 'line-height': '32px' }
};
var title = {
    extraLarge: {
        'font-size': '20px',
        'font-weight': '600',
        'line-height': '24px'
    },
    large: {
        'font-size': '18px',
        'font-weight': '600',
        'line-height': '22px'
    },
    medium: {
        'font-size': '16px',
        'font-weight': '600',
        'line-height': '20px'
    },
    small: {
        'font-size': '14px',
        'font-weight': '600',
        'line-height': '18px'
    }
};
var label = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '500',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '500',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '500', 'line-height': '14px' }
};
var body = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '14px' }
};
var paragraph = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '24px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '20px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '18px' }
};

export { body, display, headline, label, paragraph, title };
//# sourceMappingURL=const.js.map
